import React from "react";
import { Layout, NavigationBanner, SectionList } from "../../../components";
import styles from "./FuelPrimax.module.scss";
import useFetchB2B from "../../../helpers/useFetchB2B";
import b2bRoutes from "../../../helpers/b2b.routes";

const FuelPrimax = () => {
  const { currentPage, pages } = useFetchB2B({
    url: b2bRoutes.FUELS,
  });

  return (
    <Layout pageTitle="Engen PRIMAX Unleaded" withBottomPadding={false} backButton={true}>
      {currentPage ? (
        <>
          <NavigationBanner pages={pages} activePage={currentPage} />
          <div className={styles.main}>
            <SectionList sections={currentPage.sections} />
          </div>
        </>
      ) : null}
    </Layout>
  );
};

export default FuelPrimax;
